module.exports = __webpack_public_path__ + "media/images/logo-icon-724cc954d0de220d3b2721774e62691e.svg";